import { Controller } from '@hotwired/stimulus';

export default class extends Controller {

  static targets = ['image', 'imageField', 'addImageBtn', 'imageActionsBlock', 'imageWell', 'signedImage']

  connect() {
    this.initializeImage();
  }

  RemoveImage = () => {
    if (!confirm('Are you sure you want to remove this image?')) return; // eslint-disable-line no-alert

    this.removeSignedImageInput();
    this.imageFieldTarget.value = null;
    this.imageTarget.setAttribute('src', '#')
    this.showAddImageBtn()
  }

  showAddImageBtn() {
    this.addImageBtnTarget.classList.remove('hidden')
    this.imageActionsBlockTarget.classList.add('hidden')
    this.imageTarget.classList.add('hidden');
  }

  hideAddImageBtn() {
    this.addImageBtnTarget.classList.add('hidden')
    this.imageActionsBlockTarget.classList.remove('hidden')
    this.imageTarget.classList.remove('hidden')
  }

  removeSignedImageInput() {
    if (!this.hasSignedImageTarget) return

    this.signedImageTarget.remove();
  }

  AddImage(event) {
    event.preventDefault();
    event.stopPropagation();
    this.imageFieldTarget.click();
  }

  ImageAdded = event => {
    if (!event.target.files.length) return

    const file = event.target.files[0]
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = e => {
      this.imageTarget.setAttribute('src', e.target.result)
      this.removeSignedImageInput()
      this.hideAddImageBtn()
    }
  }

  initializeImage() {
    const imageSrc = this.imageTarget.getAttribute('src')

    if (!imageSrc) return;

    this.hideAddImageBtn()
  }
}
